/**
 * @function to validateService to validate controls
 * @param type act according to the type
 */

function checkDevice(){
    return (!!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))
}

const undefinedCheck = (...a) => [...a].reduce((accu, curr) => Boolean(accu) && Boolean(curr), true);
const validateService = (event, type) => {
    const fieldValidity = event.target.validity.valid;
    const wrapper = undefinedCheck(event.target) ? event.target.parentElement : '';
    const container = undefinedCheck(event.target.parentElement) ? event.target.parentElement.parentElement : '';
    const patternMatch = matchPattern(undefinedCheck(event.target.value) ? event.target.value : '', type);
    const inputId = undefinedCheck(event.target) ? event.target.id : '';
    let optionalField = false;
    (inputId.includes('zip') || inputId.includes('mtcn') || inputId.includes('middleName')) && (optionalField = true);        
    if (optionalField) {
        event.target.value.length === 0 ? (wrapper.classList.remove('wu-input__error'), container.classList.remove('reqValidate')) : fieldValidity && patternMatch ? (wrapper.classList.remove('wu-input__error'), container.classList.remove('reqValidate')) : (wrapper.classList.add('wu-input__error'), container.classList.add('reqValidate'));
    } else {
        fieldValidity && patternMatch ? wrapper.classList.remove('wu-input__error') : wrapper.classList.add('wu-input__error');
    }
}

function matchPattern (inputValue, inputType) {
    let succesfulMatch = false;
    const patternObj = {
        text: /^(?! )(?!(.)\1+$)(?!.*(.)\2{2})(?!.*( |'|-|\.)\3{1})(?=\S*(\s\S*){0,4}$)(?=[a-zA-ZÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýþÿ .]*(['-][a-zA-ZÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýþÿ .]*){0,2}$)(?=(.*[a-zA-ZÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýþÿ.]){2}.*$)^[a-zA-ZÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýþÿ '-.]{0,}\S$/,
        address: /[\s\S]*/,
        select: /[\s\S]*/,
        zip: /(?=^([a-zA-Z\d]{2}))(?!0{3,5})[A-Za-z0-9 -]{3,10}$/,
        webaddress: /^(https?:\/\/)?(www\.)?([a-zA-Z0-9]+(-?[a-zA-Z0-9])*\.)+[\w]{2,}(\/\S*)?$/,
        search: /^(?! )(?!(.)\1+$)(?!.*(.)\2{2})(?!.*( |'|-|\.)\3{1})(?=\S*(\s\S*){0,4}$)(?=[a-zA-ZÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýþÿ .]*(['-][a-zA-ZÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýþÿ .]*){0,2}$)(?=(.*[a-zA-ZÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýþÿ.]){2}.*$)^[a-zA-ZÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýþÿ '-.]{0,}\S$/,
        email: /^(\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$)/,
        number: /^(?!(.)\1+$)^(|[0-9]{7,})$/,
        mtcn: /^[\d]{10}$/,
        countryCode: /^[+0-9A-Z\(\)]{6,8}$/,
        date: /^(\d{4})\-(\d{2})\-(\d{2})$/,
        decimal: /^-?[0-9]+(\.[0-9]{0,2}){0,1}$/,
        alphanumeric: /(?!.*( )\1{1})^[0-9a-zA-Z ]+$/,
        captcha: /^[0-9a-zA-Z ]{6}$/,
        textarea: /[\s\S]*/
    }
    patternObj[inputType].test(inputValue) && (succesfulMatch = true);
    return succesfulMatch;
}

let sectionsArray = [false, false, false, false, false, false];

function validateAll(formName = '') {
    let sectionValid = true;
    for (let i = 1; i <= 6; i++) {
    let validity = validateSection(`toggle${i}`, `continueButton_${i}`, 'click', false,formName);
    if (!validity) {
            sectionValid = false;
            sectionsArray[i - 1] = false;
            validateSection(`toggle${i}`, `continueButton_${i}`, 'click', false,formName);
            break;
        }
    }
    return sectionValid;
}

function toggleField(attr, value, hide = true, required = false) {
    const field = document.querySelector(`[${attr}="${value}"]`);
    if (field) {
        const fieldDivClass = field.parentElement.classList;
        const fieldWrapperClass = field.parentElement.parentElement.classList;
        if (fieldDivClass && fieldWrapperClass) {
            hide ? (field.value = "", fieldDivClass.remove('wu-input__error'), fieldWrapperClass.add('d-none'), fieldWrapperClass.remove('reqValidate')) : (fieldWrapperClass.remove('d-none'), required ? fieldWrapperClass.add('reqValidate') : '');
        }
    }
}

// Validate Section Inputs and Select Menus on hit of Continue
function validateSection(togglerID, buttonID, b = 'click', callnext = true,formName = '') {
    let togglerNameString = undefinedCheck(togglerID) ? String(togglerID) : '';
    let togglerNumericId = undefinedCheck(togglerNameString) ? Number(togglerNameString[togglerNameString.length - 1]) : '';
    let btnNameString = undefinedCheck(buttonID) ? String(buttonID) : '';
    let btnNumericId = undefinedCheck(btnNameString) ? Number(btnNameString[btnNameString.length - 1]) : '';
    let fieldsValid = true;
    let toggleElement = document.getElementById(`${togglerID}`);
    let btnElement = document.getElementById(`${buttonID}`);
    let newtogglerId = `${togglerNameString.slice(0, -1)}${String(togglerNumericId + 1)}`;
    let newBtnId = `${btnNameString.slice(0, -1)}${String(btnNumericId + 1)}`;

    if (undefinedCheck(btnElement) && undefinedCheck(toggleElement)) {
        let section = btnElement.parentElement.parentElement.parentElement;
        if (undefinedCheck(section)) {
            let formControls = section.querySelectorAll('.reqValidate');
            if (undefinedCheck(formControls.length) && b === 'click' ) {
                for (let i = 0; i < formControls.length; i++) {
                    let formFields = formControls[i].querySelectorAll('input:not([type="file"]), select');
                    if (undefinedCheck(formFields.length)) {
                        formFields.forEach(formField => {
                            let formFieldType = formField.getAttribute('data-type');
                            (undefinedCheck(formField.value.trim()) && formField.validity.valid && matchPattern(formField.value,formFieldType)) ?
                                (formField.parentElement.classList.remove('wu-input__error')) :
                                (formField.parentElement.classList.add('wu-input__error'), fieldsValid = false);
                        });
                    }
                }
            }

            let files = section.querySelectorAll('[type="file"]');
                if (undefinedCheck(files.length) && b === 'click' ) {
                    let fileId = files[0].id.slice(0, -3);
                    let fielLabelId = `${fileId}_Label`;
                    if (undefinedCheck(attachmentData[fileId])) {
                        if(formName!="claimform"){
                        if (undefinedCheck(attachmentData[fileId].data) && undefinedCheck(attachmentData[fileId].fileName)) {
                            let fileIdLabelDiv = document.getElementById(`${fielLabelId}`);
                            fileIdLabelDiv ? fileIdLabelDiv.classList.remove('wu-input__error') : '';

                        } else {
                            let fileIdLabelDiv = document.getElementById(`${fielLabelId}`);
                            fileIdLabelDiv ? fileIdLabelDiv.classList.add('wu-input__error') : '';
                            fieldsValid = false;
                        }
                    }
                    else{
                        if (undefinedCheck(attachmentData[fileId].binary) && undefinedCheck(attachmentData[fileId].file_name)) {
                            let fileIdLabelDiv = document.getElementById(`${fielLabelId}`);
                            fileIdLabelDiv ? fileIdLabelDiv.classList.remove('wu-input__error') : '';
                        }
                    }
                    } else {
                        if(formName!="claimform"){
                        let fileIdLabelDiv = document.getElementById(`${fielLabelId}`);
                        fileIdLabelDiv ? fileIdLabelDiv.classList.add('wu-input__error') : '';
                        fieldsValid = false;
                        }
                        else { 
                            attachmentData[fileId] = {
                                "file_name": "",
                                "binary": "",
                                "format": ""
                            }
                        }
                    }
            }
            
            if (fieldsValid && b === 'click') {
                sectionsArray[togglerNumericId - 1] = true;
                let title1 = document.getElementById(`section_title_${togglerNumericId}`);
                title1 ? title1.classList.remove('text-danger') : '';                    
                if (toggleElement.checked) toggleElement.checked = !toggleElement.checked;
                else toggleElement.checked = toggleElement.checked;
                if (togglerNumericId <= 5) {
                    let newSectionToggler = document.getElementById(`${newtogglerId}`);
                    let newSectionBtn = document.getElementById(`${newBtnId}`);
                    if (undefinedCheck(newSectionToggler) && undefinedCheck(newSectionBtn)) {
                        let newclick = 'clickcall';
                        if (!sectionsArray[togglerNumericId]) {
                            if (callnext) {
                                validateSection(newtogglerId, newBtnId, newclick);
                                newSectionBtn.parentElement.parentElement.parentElement.scrollIntoView({
                                    behavior: 'smooth',
                                    block: 'start',
                                    inline: 'nearest'
                                });
                            }
                        }
                    }
                } else {
                    window.scrollTo(0, 0);
                }
            } else {
                if (!sectionsArray[togglerNumericId - 1]) {
                    let title = document.getElementById(`section_title_${togglerNumericId}`);
                    title ? title.classList.add('text-danger') : '';
                    if (toggleElement.checked) toggleElement.checked = toggleElement.checked;
                    else {
                        toggleElement.checked = !toggleElement.checked;
                        section.scrollIntoView({
                            behavior: 'smooth',
                            block: 'start',
                            inline: 'nearest'
                        });
                    }
            }
            }
        }
    }
    return fieldsValid;
}


let attachmentData = {}

function fileWidget(id, getField,counter,formName = '') {
    let photo = document.getElementById(id+"_"+getField);
    let imgPreview = document.getElementById("imgPreview_" + id);
    let file_Attach_Container = document.getElementById("FW_Con_"+id);
    let FW_Edit = document.getElementById("FW_Edit_" + id);
	let fileExtension = ["png", "jpg", "jpeg", "pdf"];
    const file = photo.files[0];
	let getFileExtension = file.name.split(".")[1].toLowerCase();
	let fileSize = file.size;
	let size = parseFloat(fileSize / (1024 * 1024)).toFixed(2);
	let pdfPreview = document.getElementById("pdfPreview_" + id);
	let editOption = document.getElementById("editOpt_" + id);
	let label_FW = document.getElementById(id + "_Label");
	let SizeInKB = parseFloat(fileSize / 1024).toFixed(2);

	if (file && (fileExtension.indexOf(getFileExtension) > -1) && (SizeInKB > 10 && size < 10)){
        let reader = new FileReader();
        reader.onload = function (event) {
			if(getFileExtension == "pdf"){
				imgPreview.classList.add('d-none'); 
				pdfPreview.classList.remove('d-none');
				pdfPreview.innerHTML = file.name;
				pdfPreview.setAttribute('title', file.name);
			}
			else{
				pdfPreview.classList.add('d-none');
				imgPreview.classList.remove('d-none');            
				imgPreview.src = URL.createObjectURL(file);
				file_Attach_Container.classList.add('opac-0');
			}
			FW_Edit.classList.remove('d-none');
            const base64String = reader.result.replace('data:', '').replace(/^.+,/, '');
            if(formName === "claimform")
            {
                attachmentData[id] = {
                    "file_name": file.name,
                    "binary": base64String,
                    "format": getFileExtension
                }
            }
            else
            {
            attachmentData[id] = {
                "fileName": file.name,
                "data": base64String
            }
        }
        };
		
		let visi = document.querySelectorAll(".setOverflowVisCont");
		visi.forEach(className => {
		className.style.overflow = "hidden";
		});	
		editOption.classList.add("d-none");
		label_FW.classList.remove("wu-input__error");
		photo.value = "";
        reader.readAsDataURL(file);
		
    }else{
		label_FW.classList.add("wu-input__error");
	}
}

function showEditOption(getId, counter) {
    let showEditLabel = document.getElementById("editOpt_" + getId);
	showEditLabel.classList.toggle('d-none');
    if(checkDevice()){
        let visi = document.getElementById("setOverflowVisCont_" + counter);
        if (showEditLabel.classList.contains("d-none")) {
            visi.style.overflow = "hidden"
        }
        else{
            visi.style.overflow = "visible";
        }
    }
}

function removeDocument(getId,formName = '') {
    let imgPreview = document.getElementById("imgPreview_" + getId);
    let FW_Edit = document.getElementById("FW_Edit_" + getId);
    let editOpt = document.getElementById("editOpt_" + getId);
	let pdfPreview = document.getElementById("pdfPreview_" + getId);
	let file_Attach_Container = document.getElementById("FW_Con_" + getId);

    FW_Edit.classList.add('d-none');
    editOpt.classList.add('d-none');
    imgPreview.classList.add('d-none');
    imgPreview.src = "";
	pdfPreview.classList.add('d-none');
	pdfPreview.innerHTML = "";
    if(formName=="claimform"){
        attachmentData[getId].file_name = '';
        attachmentData[getId].binary = '';
        attachmentData[getId].format = '';
    }
    else
    {
        attachmentData[getId].fileName = "";
        attachmentData[getId].data = "";
    }
	file_Attach_Container.classList.remove('opac-0');	
	let visi = document.querySelectorAll(".setOverflowVisCont");
	visi.forEach(className => {
		className.style.overflow = "hidden";
	});	
}